<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import Footer from '../common/Footer.svelte';
  import Loading from '../common/Loading.svelte';
  import Error from '../common/Error.svelte';
  import Title from '../common/Title.svelte';
  import TwButtonSecondary from '../tailwind/TwButtonSecondary.svelte';
  import Tweet from '../ui-components/Tweet.svelte';
  import PageBox from '../ui-components/PageBox.svelte';
  import Common from '../js/common.js';

  if (!Global.pages.includes('history')) {
    window.location.href = window.localStorage.getItem('currentPage') || './';
  }

  let lang;

  let user = JSON.parse(window.localStorage.getItem('user'));

  let history;
  let tweets = [];
  let page;

  let loading = true;
  let error = false;

  (async () => {
    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/history/get`);

    history = {
      perex: {
        // eslint-disable-next-line no-undef
        cs: await (await fetch('./file/static/history-perex-cs.md', { cache: 'no-cache' })).text(),
        // eslint-disable-next-line no-undef
        en: await (await fetch('./file/static/history-perex-en.md', { cache: 'no-cache' })).text(),
      },
      content: {
        // eslint-disable-next-line no-undef
        cs: await (await fetch('./file/static/history-content-cs.md', { cache: 'no-cache' })).text(),
        // eslint-disable-next-line no-undef
        en: await (await fetch('./file/static/history-content-en.md', { cache: 'no-cache' })).text(),
      },
    };

    if (response.ok) {
      const data = await response.json();

      tweets = data.tweets;
      page = data.page;
      user = data.user;

      tweets = Common.sortArrayOfObjectsByKey(tweets, ['timestamp'], true);

      if (user) window.localStorage.setItem('user', JSON.stringify(data.user));
      else window.localStorage.removeItem('user');
    } else {
      error = true;
    }

    loading = false;
  })();

  const i18n = {
    pageTitle: {
      cs: `Historie | ${Global.project.name.cs}`,
      en: `History | ${Global.project.name.en}`,
    },
    title: {
      cs: 'Historie',
      en: 'History',
    },
  };

  const projectStyle = Global.project.style;
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='history' bind:lang bind:user/>

<Title title={i18n.title[lang]} color={projectStyle === 'sharp' ? 'brown' : 'purple'} img='title/history.jpg' bind:lang bind:user/>

<div class='history'>
  <Loading bind:display={loading}/>
  <Error bind:display={error} bind:lang/>

  {#if !loading && !error}
    <div class='history-content'>
      <div class='history-content-box'>
        <div class='history-content-box-perex'>
          {@html Common.escapeMarkdown(history.perex[lang])}
        </div>

        <div class='history-content-box-buttons'>
          {#each history.content[lang].match(/^# (.+?)$/gm).map(year => year.slice(2)) as year}
            <TwButtonSecondary value={year} onClick={() => {
              console.log(year);
              window.scrollTo({
                behavior: 'smooth',
                // eslint-disable-next-line no-magic-numbers
                top: document.getElementById(year).getBoundingClientRect().top - document.body.getBoundingClientRect().top - 80,
              });
            }}/>
          {/each}
        </div>

        <div class='history-content-box-content'>
          {@html Common.escapeMarkdown(history.content[lang], true)}
        </div>
      </div>

      <div class='history-content-right-panel'>
        {#each tweets as tweet}
          <Tweet value={tweet} dark={true} bind:lang admin={!!user}/>
        {/each}
      </div>
    </div>

    <PageBox value={page} page='history' bind:lang bind:user/>
  {/if}
</div>

<Footer bind:lang/>

<style>
  .history {
    display: flex;
    flex-direction: column;
    gap: 40px;

    max-width: 1450px;

    padding: 40px 60px;

    margin: auto;
  }

  .history-content {
    display: flex;
    justify-content: space-between;
    gap: 40px;
  }

  .history-content-box {
    display: flex;
    flex-direction: column;
    gap: 20px;

    width: calc((100% - 40px) / 3 * 2);
  }

  .history-content-box-perex {
    font-weight: bold;

    line-height: 1.6;

    overflow-wrap: anywhere;
  }

  .history-content-box-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .history-content-box-content {
    line-height: 1.6;

    overflow-wrap: anywhere;
  }

  .history-content-right-panel {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 20px;

    width: calc((100% - 40px) / 3);

    padding: 20px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);
  }

  :global(body.dark) .history-content-right-panel {
    background: var(--grey-8);
  }

  @media only screen and (max-width: 1300px) {
    .history-content-box {
      width: 100%;
    }

    .history-content-right-panel {
      display: none;
    }
  }

  @media only screen and (max-width: 900px) {
    .history {
      padding: 40px;
    }
  }

  @media only screen and (max-width: 350px) {
    .history {
      padding: 40px 20px;
    }
  }
</style>
